var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTransnistria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4484 12.2567C29.6124 5.44448 23.392 0.430664 15.9996 0.430664C8.60716 0.430664 2.38678 5.44448 0.550781 12.2567L15.9996 12.9524L31.4484 12.2567Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 20.6044C2.38678 27.4166 8.60716 32.4304 15.9996 32.4304C23.392 32.4304 29.6124 27.4166 31.4484 20.6044L15.9996 19.9087L0.550781 20.6044Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4488 12.2568H0.551188C0.1925 13.5876 0 14.9866 0 16.4308C0 17.875 0.1925 19.2739 0.551188 20.6047H31.4489C31.8075 19.2739 32 17.875 32 16.4308C32 14.9866 31.8075 13.5876 31.4488 12.2568Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTransnistria);
export default __webpack_public_path__ + "static/media/flag_transnistria.6630e7fb036537f68b100323ab9be765.svg";
export { ForwardRef as ReactComponent };